import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
// import { Outcomes as RelationshipOutcomes } from "./RelationshipScreen";
import { Estate } from "../../../models/Estate";
import { EstateUserInfo } from "models/EstateUserInfo";

export enum Outcomes {
  executor = "Executor",
  coExecutor = "Co-executor",
  personalRep = "Personal representative",
  corporateExecutor = "Corporate executor",
  beneOrHeir = "Beneficiary or Heir",
  somethingElse = "Something else",
  skip = "Skip",
}

export const RoleScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const { flow, activeEstate, setActiveEstate, user } = useAuthContext()
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  // This is kind of spaghetti. We should handle this in the Flow.tsx file
  // useEffect(() => {
  //   const relationship =
  //     activeEstate?.estateUserInfo?.relationshipToDeceased || "";
  //   const skipIfRelationship = [
  //     RelationshipOutcomes.notRelated.toString(),
  //     RelationshipOutcomes.somethingElse.toString(),
  //   ];
  //   if (skipIfRelationship.includes(relationship)) {
  //     currentScreen &&
  //       flow?.navigateToNext(currentScreen, Outcomes.skip, navigate, {
  //         replace: true,
  //       });
  //   }
  // }, []);

  const handleComplete = async (
    role: string,
    nameOfCorporateExecutor?: string
  ): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    const estate = activeEstate || new Estate();

    if (estate.estateUserInfo) {
    } else {
      const estateUserInfo = new EstateUserInfo(undefined, user?.id, estate.id || undefined);
      estate.estateUserInfo = estateUserInfo;
    }

    estate.estateUserInfo.declaredRole = role;
    estate.estateUserInfo.nameOfCorporateExecutor =
      nameOfCorporateExecutor || undefined;

    try {
      await estate.saveEstate();
      setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, role, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title="What is your role with regard to the estate?">
      <RadioAndResponseForm
        initAnswer={activeEstate?.estateUserInfo?.declaredRole}
        initMoreAnswer={activeEstate?.estateUserInfo?.nameOfCorporateExecutor}
        answerLabel="Role"
        errorText="Please select an option to continue"
        options={[
          { value: Outcomes.executor },
          { value: Outcomes.coExecutor },
          {
            value: Outcomes.corporateExecutor,
            followUp: "Name of Corporate Executor",
          },
          // { value: Outcomes.beneOrHeir },
          { value: Outcomes.somethingElse },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
